import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import { extConfig } from './config';
import PluginInsertMenu from '../../../menus/PluginInsertMenu';
import { useEditorContext } from '../../Context';

import s from './OriginalsQuestion.scss';

const OriginalsQuestion: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId' | 'onFocus' | 'onBlur'>
> = props => {
  const [isExpanded, setIsExpanded] = useState(false);
  const editor = useEditorContext();
  const onFocus = useCallback(() => {
    setIsExpanded(true);
  }, []);
  const doFocusEditor = useCallback(() => {
    editor?.commands?.focus();
  }, [editor?.commands]);

  return (
    <div
      className={cn(
        s['root'],
        isExpanded && s['expanded'],
        props.hasError && s['error']
      )}
      onClick={doFocusEditor}
    >
      <Editor
        {...props}
        onFocus={onFocus}
        withinModal
        presetId="originals-question"
        extensionConfig={extConfig}
        className={s['editor']}
      ></Editor>
      <div className={s['toolbar']}>
        <PluginInsertMenu />
      </div>
    </div>
  );
};

export default OriginalsQuestion;
